import axios from "axios";
import errorHandler from "handlers/errorHandler";

// Change for your VM IP when testing locally
const host =
  process.env.NODE_ENV === "development"
    ? "https://127.0.0.1"
    : window.location.host;

const createAxios = () => {
  const localhost = axios.create({
    baseURL: host,
  });

  localhost.defaults.headers.common["X-Requested-With"] = "Ajax";

  // Add the crsf token header to all ajax requests
  if (process.env.NODE_ENV !== "development") {
    Object.assign(localhost.defaults.headers.common, window.vtdocs.csrf);
  }

  // Intercept request before it's called because in axios code:
  // If you don't use an absolute URL as baseURL, the config.url will always be combined with the baseURL
  // Ending up in duplicated base url
  localhost.interceptors.request.use(
    (config) => {
      if (process.env.NODE_ENV !== "development") {
        config.baseURL = "";
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // apply interceptor on response
  localhost.interceptors.response.use(
    (response) => response,
    (error) => {
      errorHandler(error.response);
      return Promise.reject(error);
    }
  );

  return localhost;
};

const getAxios = () =>
  // If tests are running, then mock axios, else create new axios instance
  process.env.JEST_WORKER_ID !== undefined
    ? jest.createMockFromModule("axios").default
    : createAxios();

const localhost = getAxios();

export const downloadFileFromResponse = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(link.href);
};

export const downloadWithIFrame = (url) => {
  const iframe = document.createElement("iframe");
  iframe.src = url;
  iframe.style.display = "none";
  document.body.appendChild(iframe);
};

export const METHODS = {
  get: "get",
  post: "post",
  put: "put",
  patch: "patch",
  delete: "delete",
};

export const mockRequest = (method, data) => {
  localhost[method].mockImplementation(() =>
    Promise.resolve({
      data,
    })
  );
};

export const mockRejectRequest = (method, message) => {
  const error = {
    response: {
      data: {
        error: message,
      },
    },
  };
  localhost[method].mockImplementation(() => Promise.reject(error));
};

export default localhost;
